<template>
  <div>
    <!-- <div>学生考勤---我的考勤</div> -->
    <div class="select-time">
      <div class="select-btn" @click="changeType">
        {{typeName}}
        <img :src="require('@/assets/attendance/switch@2x.png')" />
      </div>
      <div class="line"></div>
      <!-- 日 -->
      <div v-if="num === 1" class="time-show">
        <span class="time-date">
          <img :src="require('@/assets/attendance/left@2x.png')" @click="beforeDay(0,newDate)" />
          <span class="time-date">
            <span>{{newDate}}</span>
          </span>
          <img :src="require('@/assets/attendance/right@2x.png')" @click="beforeDay(1,newDate)" />
        </span>
      </div>
      <!-- 周 -->
      <div v-if="num === 2" class="time-show">
        <img
          :src="require('@/assets/attendance/left@2x.png')"
          @click="beforeWeek(0,newWeekBegin,newWeekEnd)"
        />
        <span class="time-date">
          <span>{{newWeekBegin}}</span>~
          <span>{{newWeekEnd}}</span>
        </span>
        <img
          :src="require('@/assets/attendance/right@2x.png')"
          @click="beforeWeek(1,newWeekBegin,newWeekEnd)"
        />
      </div>
      <!-- 月 -->
      <div v-if="num === 3" class="time-show">
        <img
          :src="require('@/assets/attendance/left@2x.png')"
          @click="beforeMonth(newMonthBegin,newMonthEnd)"
        />
        <span class="time-date">
          <span>{{newMonthBegin}}</span>~
          <span>{{newMonthEnd}}</span>
          <!-- <span>{{newMonthEnd > newDate ? newDate : newMonthEnd}}</span> -->
        </span>
        <img
          :src="require('@/assets/attendance/right@2x.png')"
          @click="afterMonth(newMonthBegin,newMonthEnd)"
        />
      </div>
      <!-- 学期 -->
      <div v-if="num === 4" class="time-show">
        <span class="time-date">
          <span>{{newTermBegin}}</span>~
          <!-- <span>{{newTermEnd > newDate ? newDate : newTermEnd}}</span>学期为整个 -->
          <span>{{newTermEnd}}</span>
        </span>
      </div>
      <!-- 自定义 -->
      <div v-if="num === 5" class="time-show">
        <span class="time-date">
          <span @click="openStartDate">{{xy.moment(newCustomBegin).format('YYYY.MM.DD') }}</span>~
          <span @click="openEndDate">{{xy.moment(newCustomEnd).format('YYYY.MM.DD') }}</span>
        </span>
      </div>
    </div>

    <!-- 选择开始时间 -->
    <van-popup v-model="isShowStartDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        v-model="startCurrentDate"
        @cancel="startCancel"
        @confirm="startConfirm"
        :formatter="formatter"
        type="date"
      ></van-datetime-picker>
    </van-popup>
    <!-- 选择结束时间 -->
    <van-popup v-model="isShowEndDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        v-model="endCurrentDate"
        @cancel="endCancel"
        @confirm="endConfirm"
        :formatter="formatter"
        type="date"
      ></van-datetime-picker>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "MyAttendance",
  data() {
    return {
      typeName: "按日统计",
      num: 0,
      moreShow: false,
      // maxDate: new Date(),

      newDate: "",
      newWeekBegin: "",
      newWeekEnd: "",
      newMonthBegin: "",
      newMonthEnd: "",
      newTermBegin: "",
      newTermEnd: "",
      newCustomBegin: this.xy.moment(),
      newCustomEnd: this.xy.moment(),

      isShowStartDate: false,
      startCurrentDate: new Date(),
      startDate: "", //开始时间
      startHour: "",

      isShowEndDate: false,
      endCurrentDate: new Date(),
      endDate: "", //结束时间
      endHour: "",
      //date搜索
      maxDate: new Date(),

      schoolList: [],
      gradelList: [],
      classData: [],

      schoolID: 0,
      gradelID: 0,
      classID: 0,
      schoolName: "",
      gradelName: "",
      className: "",
      isShow: false,
      // 最后提交的值
      timeDate: []
    };
  },
  created() {
    this.changeType();
  },
  mounted() {},

  methods: {
    // 切换类型
    changeType() {
      this.num++;
      if (this.num === 6) {
        this.num = 1;
        this.typeName = "按日统计";
        this.getDate();
      } else if (this.num === 1) {
        this.typeName = "按日统计";
        this.getDate();
      } else if (this.num === 2) {
        this.typeName = "按周统计";
        this.getWeek();
      } else if (this.num === 3) {
        this.typeName = "按月统计";
        this.getMonth();
      } else if (this.num === 4) {
        this.getTerm();
        this.typeName = "按学期统计";
      } else if (this.num === 5) {
        this.typeName = "自定义";
        this.startCurrentDate = new Date();
        this.endCurrentDate = new Date();
        this.newCustomBegin = this.xy.moment();
        this.newCustomEnd = this.xy.moment();
        this.getCustom();
      }
    },

    // 获取当日
    getDate() {
      this.num = 1;
      // this.newDate = xy.moment(new Date()).format("YYYY/MM/DD");
      this.newDate = new Date().pattern("yyyy.MM.dd");
      this.timeDate[0] = this.newDate;
      this.timeDate[1] = this.newDate;
      this.$emit("timeDate", this.timeDate);
    },

    // 获取当前周
    getWeek() {
      var date = new Date(); // 本周一的日期
      // 周第一天
      date.setDate(date.getDate() - date.getDay() + 1);
      let Year = date.getFullYear();
      let Month = date.getMonth() + 1;
      let Day = date.getDate();
      if (Month < 10) {
        Month = "0" + Month;
      }
      if (Day < 10) {
        Day = "0" + Day;
      }
      this.newWeekBegin = Year + "." + Month + "." + Day;

      // 周最后一天
      date.setDate(date.getDate() + 6);
      let YearEnd = date.getFullYear();
      let MonthEnd = date.getMonth() + 1;
      let DayEnd = date.getDate();
      if (MonthEnd < 10) {
        MonthEnd = "0" + MonthEnd;
      }
      if (DayEnd < 10) {
        DayEnd = "0" + DayEnd;
      }
      this.newWeekEnd = YearEnd + "." + MonthEnd + "." + DayEnd;
      // this.newWeekEnd = new Date().pattern("yyyy.MM.dd")
      this.timeDate[0] = this.newWeekBegin;
      this.timeDate[1] = this.newWeekEnd;
      this.$emit("timeDate", this.timeDate);
    },

    // 获取当前月
    getMonth() {
      var date = new Date(); //当前日期
      var nowMonth = date.getMonth(); //当前月
      var nowYear = date.getFullYear(); //当前年
      //本月的开始时间
      var monthStartDate = new Date(nowYear, nowMonth, 1).pattern("yyyy.MM.dd");
      //本月的结束时间
      var monthEndDate = new Date(nowYear, nowMonth + 1, 0).pattern(
        "yyyy.MM.dd"
      );
      this.newMonthBegin = monthStartDate;
      this.newMonthEnd = monthEndDate;
      this.timeDate[0] = this.newMonthBegin;
      this.timeDate[1] = this.newMonthEnd;
      this.$emit("timeDate", this.timeDate);
    },

    // 获取当前学期
    async getTerm() {
      let res = await this.xyapi.get(
        `${this.xyMApi}/base/api/AcademicSession/GetCurrent`
      );
      if (res.success) {
        // this.newTermBegin = res.data.StartDate;
        // this.newTermEnd = res.data.EndDate;
        this.newTermBegin = new Date(res.data.StartDate).pattern("yyyy.MM.dd");
        this.newTermEnd = new Date(res.data.EndDate).pattern("yyyy.MM.dd");
        this.timeDate[0] = this.newTermBegin;
        this.timeDate[1] = this.newTermEnd;
        this.$emit("timeDate", this.timeDate);
      } else {
        this.$toast.fail(res.msg);
      }
    },

    // 获取当前自定义
    getCustom() {
      this.timeDate[0] = new Date(this.newCustomBegin).pattern("yyyy/MM/dd");
      this.timeDate[1] = new Date(this.newCustomEnd).pattern("yyyy/MM/dd");
      this.$emit("timeDate", this.timeDate);
    },

    // 打开自定义时间---开始选择框
    openStartDate() {
       this.isShowStartDate = true
    },

    // 打开自定义时间---结束选择框
    openEndDate() {
       this.isShowEndDate = true
    },

    //取消选择开始时间
    startCancel() {
      this.isShowStartDate = false;
    },

    //确认选择开始时间
    startConfirm(value) {
      let time = value.pattern("yyyy/MM/dd");
      this.startHour = value.pattern("HH:mm");
      // this.timeDate[0] = time;
      if (this.timeDate[1] === "结束时间") {
        this.isShowStartDate = false;
        return;
      } else {
        let m1 = this.xy.moment(time);
        let m2 = this.xy.moment(this.newCustomEnd);
        let dayNum = m2.diff(m1, "day");
        console.log(m1);
        console.log(m2);
        console.log(dayNum);
        if (dayNum >= 0) {
          this.newCustomBegin = time;
          this.isShowStartDate = false;
          this.timeDate[0] = time;
          this.$emit("timeDate", this.timeDate);
        } else {
          return this.$toast.fail("开始时间不能晚于结束时间");
          // eslint-disable-next-line no-unreachable
          this.$emit("timeDate", "");
        }
      }
    },

    //取消选择结束时间
    endCancel() {
      this.isShowEndDate = false;
    },

    //确认选择结束时间
    endConfirm(value) {
      let time = value.pattern("yyyy/MM/dd");
      this.endHour = value.pattern("HH:mm");
      // this.timeDate[1] = time;
      if (this.timeDate[0] === "开始时间") {
        this.isShowEndDate = false;
        return;
      } else {
        let m1 = this.xy.moment(this.newCustomBegin);
        let m2 = this.xy.moment(time);
        let dayNum = m2.diff(m1, "day");
        console.log(m1);
        console.log(m2);
        console.log(dayNum);
        if (dayNum >= 0) {
          this.newCustomEnd = time;
          this.isShowEndDate = false;
          this.timeDate[1] = time;
          this.$emit("timeDate", this.timeDate);
        } else {
          return this.$toast.fail("结束时间不能早于开始时间");
          // eslint-disable-next-line no-unreachable
          this.$emit("timeDate", " ");
        }
      }
    },

    // 格式化日期，传入日期对象   =>2019-01-11
    dateFormat(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m <= 9) {
        m = "0" + m;
      }
      if (d <= 9) {
        d = "0" + d;
      }
      return y + "-" + m + "-" + d;
    },

    // 向前, 后一日
    beforeDay(type, date) {
      let forMatDate = date.replace(/\./g, "/"); // 格式化日期 2019-02-23 => 2019/02/23
      let d = new Date(forMatDate); // new Date() 不能识别 2019-01-02  需转化为 2019/01/02
      if (type === 0) {
        d = +d - 1000 * 60 * 60 * 24;
      } else if (type === 1) {
        d = +d + 1000 * 60 * 60 * 24; // d前面需要加上 +
      }
      d = new Date(d);
      var t1 = this.dateFormat(d);
      var arr = t1.split("-"); // 开始日期
      var year = arr[0]; //获取开始日期的年份
      var month = arr[1]; //获取开始日期的月份
      var day = arr[2]; //获取开始日期的日
      this.newDate = year + "." + month + "." + day;
      // this.newDate = xy.moment(new Date()).format("YYYY/MM/DD");
      // this.newDate = new Date().pattern("yyyy.MM.dd");
      this.timeDate[0] = this.newDate;
      this.timeDate[1] = this.newDate;
      this.$emit("timeDate", this.timeDate);
    },

    // 向前，后一周
    beforeWeek(type, date1, date2) {
      let forMatDate1 = date1.replace(/\./g, "/"); // 格式化日期 2019-02-23 => 2019/02/23
      let forMatDate2 = date2.replace(/\./g, "/"); // 格式化日期 2019-02-23 => 2019/02/23
      let d = new Date(forMatDate1); // new Date() 不能识别 2019-01-02  需转化为 2019/01/02
      let a = new Date(forMatDate2); // new Date() 不能识别 2019-01-02  需转化为 2019/01/02
      if (type === 0) {
        d = +d - 1000 * 60 * 60 * 24 * 7;
        a = +a - 1000 * 60 * 60 * 24 * 7;
      } else if (type === 1) {
        d = +d + 1000 * 60 * 60 * 24 * 7; // d前面需要加上 +
        a = +a + 1000 * 60 * 60 * 24 * 7; // d前面需要加上 +
      }
      d = new Date(d);
      a = new Date(a);
      var t1 = this.dateFormat(d);
      var t2 = this.dateFormat(a);

      var arr = t1.split("-"); // 开始日期
      var year = arr[0]; //获取开始日期的年份
      var month = arr[1]; //获取开始日期的月份
      var day = arr[2]; //获取开始日期的日

      var arr2 = t2.split("-"); // 开始日期
      var year2 = arr2[0]; //获取开始日期的年份
      var month2 = arr2[1]; //获取开始日期的月份
      var day2 = arr2[2]; //获取开始日期的日

      this.newWeekBegin = year + "." + month + "." + day;
      this.newWeekEnd = year2 + "." + month2 + "." + day2;
      this.timeDate[0] = this.newWeekBegin;
      this.timeDate[1] = this.newWeekEnd;
      this.$emit("timeDate", this.timeDate);
    },

    // 向前一月
    beforeMonth(val1) {
      var arr = val1.split("."); // 开始日期
      var year = arr[0]; //获取开始日期的年份
      var month = arr[1]; //获取开始日期的月份
      var day = arr[2]; //获取开始日期的日

      var year1 = year;
      var month1 = parseInt(month) - 1;
      if (month1 === 0) {
        year1 = parseInt(year1) - 1;
        month1 = 12;
      }

      var day1 = day;
      var days2 = new Date(year1, month1, 0);
      var t3 = days2.pattern("yyyy.MM.dd");
      this.newMonthEnd = t3;

      days2 = days2.getDate();
      if (day1 > days2) {
        day1 = days2;
      }
      if (month1 < 10) {
        month1 = "0" + month1;
      }
      var t2 = year1 + "." + month1 + "." + day1;
      this.newMonthBegin = t2;
      this.timeDate[0] = this.newMonthBegin;
      this.timeDate[1] = this.newMonthEnd;
      this.$emit("timeDate", this.timeDate);
    },

    // 向后一月
    afterMonth(val1) {
      var arr = val1.split(".");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日

      var year1 = year;
      var month1 = parseInt(month) + 1;
      if (month1 === 13) {
        year1 = parseInt(year1) + 1;
        month1 = 1;
      }

      var day1 = day;
      var days2 = new Date(year1, month1, 0);
      var t3 = days2.pattern("yyyy.MM.dd");
      this.newMonthEnd = t3;

      days2 = days2.getDate();
      if (day1 > days2) {
        day1 = days2;
      }
      if (month1 < 10) {
        month1 = "0" + month1;
      }

      var t2 = year1 + "." + month1 + "." + day1;
      this.newMonthBegin = t2;
      this.timeDate[0] = this.newMonthBegin;
      this.timeDate[1] = this.newMonthEnd;
      this.$emit("timeDate", this.timeDate);
    },

    //选项格式化
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },

    // 日期格式化 date:时间，val:前后，day:按天，周，月
    date(val, day, date1, date2) {
      var day1 = new Date(date1);
      var day2 = new Date(date2);
      // val 0 向前
      // val 1 向后

      if (val === 0) {
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * day);
        day2.setTime(day2.getTime() - 24 * 60 * 60 * 1000 * day);
      } else if (val === 1) {
        day1.setTime(day1.getTime() + 24 * 60 * 60 * 1000 * day);
        day2.setTime(day2.getTime() + 24 * 60 * 60 * 1000 * day);
      }
      // var s1 = day1.getFullYear() + "." + day1.getMonth() + 1 + "." + day1.getDate();
      let Year = day1.getFullYear();
      let Month = day1.getMonth() + 1;
      let Day = day1.getDate();
      if (Day < 10) {
        Day = "0" + Day;
      }
      var day3 = day2.getDate();
      if (day3 < 10) {
        day3 = "0" + day3;
      }
      var s1 = Year + "." + Month + "." + Day;
      var s2 = day2.getFullYear() + "." + Month + "." + day3;

      // 按日统计
      if (this.num === 1) {
        this.newDate = s1;
      } else if (this.num === 2) {
        this.newWeekBegin = s1;
        this.newWeekEnd = s2;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.select-time {
  width: 82%;
  height: 72px;
  background: #f3f3f3;
  margin: 8px 20px;
  padding-left: 20px;
  display: flex;
  overflow: hidden;
  vertical-align: middle;
  .select-btn {
    display: inline-block;
    height: 72px;
    line-height: 72px;
    // width: 32%;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    font-size: 24px;
    color: rgba(22, 22, 22, 1);
    img {
      width: 26px;
      margin: 0 15px;
    }
  }
  .line {
    display: inline-block;
    width: 2px;
    height: 28px;
    line-height: 28px;
    margin-top: 24px;
    background: #d3d3d3;
  }
  .time-show {
    display: inline-block;
    white-space: pre;
    line-height: 70px;
    img {
      width: 18px;
      display: inline-block;
      margin: 0 15px;
    }
    .time-date {
      display: inline-block;
      text-align: center;
      white-space: pre;
      white-space: nowrap;
      span {
        font-size: 24px;
        margin: 0 10px;
      }
    }
  }
}
.select-more {
  display: inline-block;
  vertical-align: middle;
  span {
    margin-right: 10px;
    font-size: 28px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: rgba(96, 96, 96, 1);
  }
  img {
    width: 24px;
  }
}
.stat-show {
  width: 100%;
  margin: 8px 20px;
  span {
    color: #2980fe;
    background: #d7e7ff;
    border-radius: 2px;
    margin-right: 20px;
    padding: 3px 10px;
  }
}
</style>